export default "__VITE_ASSET__BiZkB_Xz__"